<h2 mat-dialog-title>{{data?.title}}</h2>

<mat-dialog-content style="color: rgb(54, 54, 54);">
    {{data?.message}}
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button color="warn" [mat-dialog-close]="false">{{data?.cancelText}}</button>
    <button mat-flat-button color="primary" [mat-dialog-close]="true">{{data?.confirmText}}</button>
</mat-dialog-actions>